import { Component, Input, inject } from '@angular/core';
import { ModalRef } from './../modal';
import { ConfirmationSource, ConfirmationType } from './confirmation.type';

@Component({
  selector: 'eg-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss'],
  standalone: false,
})
export class ConfirmationComponent {
  private modalRef = inject(ModalRef);

  @Input() source: ConfirmationSource;
  @Input() type: ConfirmationType;
  @Input() data: string | number;
  @Input() status: string;
  @Input() multiMessage = false;
  @Input() sources: ConfirmationSource[];

  readonly TRANSLOCO_PREFIX = 'confirmation';

  onCloseClick(): void {
    this.modalRef.close();
  }

  onResponseClick(response?: string): void {
    if (response) {
      this.modalRef.close(response);
    }
    if (this.type === 'delete') {
      this.modalRef.close('DELETE');
      return;
    }

    if (this.type === 'cancel') {
      this.modalRef.close('CANCEL');
      return;
    }

    if (this.type === 'update') {
      this.modalRef.close('UPDATE');
      return;
    }
  }
}
